module.exports = __webpack_public_path__ + "1.5.0-unryo/img/calendar-badge-outline.a2e28d91.svg";